import { useState, useEffect } from 'react';

function useFlagController<T>(msg: T) {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    if (!isFirstRender) {
      setIsShowing(true);
      setTimeout(() => {
        setIsShowing(false);
      }, 10000);
    } else {
      setIsFirstRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msg]);

  return { isShowing, setIsShowing };
}

export default useFlagController;
